var map = {
	"./1B.svg": 61,
	"./1J.svg": 62,
	"./2B.svg": 36,
	"./2C.svg": 63,
	"./2D.svg": 64,
	"./2H.svg": 65,
	"./2J.svg": 66,
	"./2S.svg": 67,
	"./3C.svg": 68,
	"./3D.svg": 69,
	"./3H.svg": 70,
	"./3S.svg": 71,
	"./4C.svg": 72,
	"./4D.svg": 73,
	"./4H.svg": 74,
	"./4S.svg": 75,
	"./5C.svg": 76,
	"./5D.svg": 77,
	"./5H.svg": 78,
	"./5S.svg": 79,
	"./6C.svg": 80,
	"./6D.svg": 81,
	"./6H.svg": 82,
	"./6S.svg": 83,
	"./7C.svg": 84,
	"./7D.svg": 85,
	"./7H.svg": 86,
	"./7S.svg": 87,
	"./8C.svg": 88,
	"./8D.svg": 89,
	"./8H.svg": 90,
	"./8S.svg": 91,
	"./9C.svg": 92,
	"./9D.svg": 93,
	"./9H.svg": 94,
	"./9S.svg": 95,
	"./AC.svg": 96,
	"./AD.svg": 97,
	"./AH.svg": 98,
	"./AS.svg": 99,
	"./JC.svg": 100,
	"./JD.svg": 101,
	"./JH.svg": 102,
	"./JS.svg": 103,
	"./KC.svg": 104,
	"./KD.svg": 105,
	"./KH.svg": 106,
	"./KS.svg": 107,
	"./QC.svg": 108,
	"./QD.svg": 109,
	"./QH.svg": 110,
	"./QS.svg": 111,
	"./TC.svg": 112,
	"./TD.svg": 113,
	"./TH.svg": 114,
	"./TS.svg": 115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;